import {useState, useEffect} from 'react';
import axios from "../../utils/axios";

export default function useGetServices() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function fetchData() {
    try {
      setLoading(true);
      const response = await axios.get('/servicios/servicios_por_estado?estado=true');
      console.log('response', response);
      setServices(response.data.data);
      setLoading(false)
    } catch(err) {
      setLoading(false)
      console.log(err);
      setError(err)
    }
  }

  useEffect(() => {
    fetchData();
  }, [])

  return {services, loading, error};
}
